
export const BLOG_API_BASE =
  process.env.REACT_APP_API_URL ||
  (typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname)
    ? "http://localhost:5001"
    : "https://api.rankifydev.com");

export async function blogRequest(path, options = {}) {
  const response = await fetch(
    `${BLOG_API_BASE}/api/blog${path}`,
    options
  );

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.message || `Request failed (${response.status})`);
  }

  return data;
}

export function imageUrl(url) {
  if (!url) return "";

  const value = String(url).trim();

  if (!value) return "";
  if (/^(data:|blob:)/i.test(value)) return value;

  if (/^https?:\/\//i.test(value)) {
    try {
      const parsed = new URL(value);

      const isLocal =
        typeof window !== "undefined" &&
        ["localhost", "127.0.0.1"].includes(window.location.hostname);

      if (
        isLocal &&
        ["api.rankifydev.com", "rankifydev.com"].includes(
          parsed.hostname
        ) &&
        parsed.pathname.startsWith("/uploads/")
      ) {
        return `http://localhost:5001${parsed.pathname}${parsed.search}`;
      }

      return value;
    } catch {
      return value;
    }
  }

  if (value.startsWith("//")) {
    return `${window.location.protocol}${value}`;
  }

  const normalizedPath = value.startsWith("/")
    ? value
    : `/${value}`;

  return `${BLOG_API_BASE}${normalizedPath}`;
}

export function formatDate(value) {
  if (!value) return "";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(date);
}
